// NOTE -  this must be kept in sync with the `TokenTimeseriesColumns` definition in `rwa-api`
export enum TokenTimeseriesColumns {
    date = "date",
    assetClassID = "asset_class_id",
    assetClassName = "asset_class_name",
    assetClassSlug = "asset_class_slug",
    assetType = "asset_type",
    assetID = "asset_id",
    peggedAssetID = "pegged_asset_id",
    peggedAssetType = "pegged_asset_type",
    assetTicker = "asset_ticker",
    issuerID = "issuer_id",
    issuerName = "issuer_name",
    jurisdictionCountryID = "jurisdiction_country_id",
    jurisdictionCountryName = "jurisdiction_country_name",
    measureID = "measure_id",
    measureSlug = "measure_slug",
    networkID = "network_id",
    networkName = "network_name",
    parentNetworkID = "parent_network_id",
    parentNetworkName = "parent_network_name",
    protocolID = "protocol_id",
    protocolName = "protocol_name",
    baseProtocolID = "base_protocol_id",
    baseProtocolName = "base_protocol_name",
    isInvestable = "is_investable",
    hidden = "hidden",
    tokenizationTypeID = "tokenization_type_id",
    tokenizationTypeName = "tokenization_type_name",
    tokenCount = "token_count",
    tokenHidden = "token_hidden",
    managerID = "manager_id",
    managerName = "manager_name",
    auditorID = "auditor_id",
    auditorName = "auditor_name",
    cryptoBrokerID = "crypto_broker_id",
    cryptoBrokerName = "crypto_broker_name",
    cryptoCustodianID = "crypto_custodian_id",
    cryptoCustodianName = "crypto_custodian_name",
    fundAdministratorID = "fund_administrator_id",
    fundAdministratorName = "fund_administrator_name",
    payingAgentID = "paying_agent_id",
    payingAgentName = "paying_agent_name",
    subAdvisorID = "sub_advisor_id",
    subAdvisorName = "sub_advisor_name",
    traditionalBrokerID = "traditional_broker_id",
    traditionalBrokerName = "traditional_broker_name",
    transferAgentID = "transfer_agent_id",
    transferAgentName = "transfer_agent_name",
    traditionalCustodianID = "traditional_custodian_id",
    traditionalCustodianName = "traditional_custodian_name",
}

// NOTE -  this must be kept in sync with the `TokenTimeseriesGroupBy` definition in `rwa-api`
export enum TokenTimeseriesGroupBy {
    asset = "asset",
    assetTicker = "asset_ticker",
    token = "token",
    assetClass = "asset_class",
    issuer = "issuer",
    jurisdictionCountry = "jurisdiction_country",
    measure = "measure",
    network = "network",
    parentNetwork = "parent_network",
    peggedAsset = "pegged_asset",
    peggedAssetType = "pegged_asset_type",
    assetType = "asset_type",
    manager = "manager",
    protocol = "protocol",
    baseProtocol = "base_protocol",
    realEstateCountry = "real_estate_country",
    auditor = "auditor",
    cryptoBroker = "crypto_broker",
    cryptoCustodian = "crypto_custodian",
    fundAdministrator = "fund_administrator",
    payingAgent = "paying_agent",
    subAdvisor = "sub_advisor",
    traditionalBroker = "traditional_broker",
    transferAgent = "transfer_agent",
    exchangeAgent = "exchange_agent",
    traditionalCustodian = "traditional_custodian",
}

export type TimeSeriesPoint = [string, number];

export interface TimeSeriesGroup {
    id: number;
    type: string;
    name: string;
    slug: string;
    color: string | null;
    // ENHANCEMENT - add icon_url to the API response?
    icon_url?: string | null;
}

export enum TimeSeriesUnits {
    token = "token",
    dollar = "dollar",
    dollars = "Dollars", // TODO - remove either `dollar` or `Dollars`
    percent = "percent",
    year = "year",
    address = "address",
}

export interface TokenTimeSeriesMeasure {
    id: number;
    slug: string;
    name: string;
    unit: TimeSeriesUnits;
}

export interface TimeSeriesItem {
    measure: TokenTimeSeriesMeasure;
    group: TimeSeriesGroup;
    points: TimeSeriesPoint[];
    // points: { [key: string]: number };
}

export interface AggregateItem {
    value: number;
    date: string;
    item_count: number;
    asset_count: number;
    reporting_asset_count: number;
    measure: TokenTimeSeriesMeasure;
    group: TimeSeriesGroup;
}

export enum ChartTypes {
    area = "area",
    line = "line",
    column = "column",
}

export interface TimeSeriesView {
    item: TimeSeriesItem;
    enabled: boolean;
    chartType: ChartTypes;
    invertYAxis?: boolean;
    lineWidth?: number;
    opacity?: number;
    showInLegend?: boolean;
    zIndex?: number;
}

/**
 * Removes the last data point from each TokenTimeSeriesItem if it represents the current incomplete week
 * @param item TokenTimeSeriesItem object to process
 * @returns The TokenTimeSeriesItem with incomplete week data point removed if applicable
 */
// export function removeIncompleteWeek(item: TokenTimeSeriesItem): TokenTimeSeriesItem {
//     const lastPoint = item.points[item.points.length - 1];
//     if (!lastPoint) return item;

//     const lastPointDate = new Date(lastPoint[0]);
//     const today = new Date();

//     // Calculate the start of the current week in UTC (assuming week starts on Sunday)
//     const startOfCurrentWeek = new Date(
//         Date.UTC(
//             today.getUTCFullYear(),
//             today.getUTCMonth(),
//             today.getUTCDate(),
//         ),
//     );
//     startOfCurrentWeek.setUTCDate(today.getUTCDate() - today.getUTCDay());

//     // Check if last point is in the current week in UTC
//     const isCurrentWeek =
//         lastPointDate >= startOfCurrentWeek && lastPointDate <= today;

//     if (isCurrentWeek) {
//         // Return a copy of item with last point removed
//         return {
//             ...item,
//             points: item.points.slice(0, -1),
//         };
//     }

//     return item;
// }
